var map = {
	"./application-1.svg": 76555,
	"./application-2.svg": 37720,
	"./arrow.svg": 90600,
	"./check.svg": 87471,
	"./location.svg": 80676,
	"./phone.svg": 37755,
	"./platform-1.svg": 71426,
	"./platform-2.svg": 25969,
	"./platform-ability.svg": 65789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;